import { inject, provideAppInitializer } from '@angular/core';

import { PromptRefreshService } from './prompt-refresh.service';

function initialiseRefresh(trackJsService: PromptRefreshService) {
  return () => trackJsService.initialise();
}

export function providePromptRefresh() {
  return [
    provideAppInitializer(() => {
      const initializerFn = initialiseRefresh(inject(PromptRefreshService));
      return initializerFn();
    }),
  ];
}
